module.exports = __webpack_public_path__ + "static/img/cp3.97afbc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cp3.png
// module id = wGNs
// module chunks = 0